var path = '/payments/payment/_sidebar.html';
var html = "<div> <h3 data-test-id=accounts_payments_plan_name> {{payment.order.product_name}} </h3> <table class=\"checkout order opacity-anim\" ng-if=payment.order> <tr> <td>Monthly subscription</td> <td data-test-id=accounts_payments_plan_price>{{payment.order.price|currency:payment.cur}}</td> </tr> <tr> <td>Total per month</td> <td data-test-id=accounts_payments_plan_total_price> {{payment.order.price|currency:payment.cur}} </td> </tr> </table> </div> <p class=note> * Applicable taxes will be calculated before checkout </p> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./payments/payment/_sidebar.html
// module id = 279
// module chunks = 0